module.exports = __webpack_public_path__ + "assets/media/sword.a8277248.mp3";